import { render, staticRenderFns } from "./CandidateProfile.vue?vue&type=template&id=0b6aa0c8&scoped=true"
import script from "./CandidateProfile.vue?vue&type=script&lang=js"
export * from "./CandidateProfile.vue?vue&type=script&lang=js"
import style0 from "./CandidateProfile.vue?vue&type=style&index=0&id=0b6aa0c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6aa0c8",
  null
  
)

export default component.exports